import { render, staticRenderFns } from "./dx_order.vue?vue&type=template&id=66094ca0&scoped=true&"
import script from "./dx_order.vue?vue&type=script&lang=js&"
export * from "./dx_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66094ca0",
  null
  
)

component.options.__file = "dx_order.vue"
export default component.exports